import { useState } from 'react'
import { Alert, Stack } from '@common/ui'
import FileInput from '../../../../components/input/FileInput'
import { resolveMimeType } from '../../../../util/mimeType'

type AssetFilePayloadEditorProps = {
  existingResourceKey: string | undefined
  onFileResolved: (file: File, mimeType: string) => void
}

const AssetFilePayloadEditor = ({ existingResourceKey, onFileResolved }: AssetFilePayloadEditorProps) => {
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined)

  const handleFileChange = async (file: File) => {
    const mimeType = await resolveMimeType(file)
    setSelectedFile(file)
    onFileResolved(file, mimeType)
  }

  return (
    <Stack gap="xs">
      <FileInput onChange={handleFileChange} />
      {!existingResourceKey && !selectedFile && <Alert severity="info">Select a file to upload for this asset.</Alert>}
    </Stack>
  )
}

export default AssetFilePayloadEditor
